import { useSelector } from "react-redux";
import { NavLink } from "react-router";

import urls from "@/constants/Urls";

import { Card, CardMedia, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";

function ImageFile({ file, select }) {
  const pbx = useSelector((state) => state.domain.pbx);

  const cardMediaProps = select
    ? {
        onClick: () => select(file, "image"),
      }
    : {
        component: NavLink,
        to: `image/${file.id}`,
      };

  return (
    <Card
      sx={{
        overflow: "hidden",
        position: "relative",
        "&:hover": {
          cursor: "pointer",
        },
      }}
      id={`image-${file.id}`}
    >
      <CardMedia
        sx={{
          height: 120,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
        }}
        image={`${urls.image}${pbx.context}%2F${file.id}.${file.contentType}?alt=media&token=${file.token}&ua=${file.updatedAt}`}
        {...cardMediaProps}
      />
      <Paper
        variant="acrylic"
        sx={{
          px: 1.5,
          py: 0.5,
          position: "absolute",
          maxWidth: "calc(100% - 8px)",
          bottom: 4,
          left: 4,
          textDecoration: "none",
        }}
        {...cardMediaProps}
      >
        <Typography
          variant="body1"
          sx={{
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
        >
          {file.name}
        </Typography>
      </Paper>
    </Card>
  );
}

ImageFile.propTypes = {
  file: PropTypes.object,
  select: PropTypes.func,
};

export default ImageFile;
